import moment from 'moment';
export default {
	getSearchDates_({ searchParams: { strDt, endDt } }) {
		return [moment(strDt).format('YYYY-MM-DD'), moment(endDt).format('YYYY-MM-DD')];
	},
	// hasChanged_({ selectedRow }) {
	// 	const custCd = selectedRow.custCd || '';
	// 	const oldCustCd = selectedRow.oldCustCd || '';
	// 	return custCd !== oldCustCd;
	// },
	getFormDatas_({ selectedRow }) {
		const formData = new FormData();

		// 마스터 데이터 (단 건) 폼데이터 전환
		for (const [key, val] of Object.entries(selectedRow)) {
			if (!val) continue;
			else formData.set(key, val);
		}
		
		return formData;
	},
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001538'), //제품ID.
				prop: 'pmcId',
				minWidth: '160px',
				custom: true,
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001044'), // HTWO판매일
				prop: 'erpSaleDd',
				minWidth: '130px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001009'), // HTWO판매일
				prop: 'jvCpnyNm',
				width: '100px',
				headerAlign: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002104'), //유효재고기간
				prop: 'eil',
				minWidth: '80px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000960'), //차량VIN
				prop: 'carVin',
				minWidth: '90px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001012'), // OEM판매일
				prop: 'oemSaleDd',
				minWidth: '100px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001541'), // OEM판매일
				prop: 'oemCpnyNm',
				minWidth: '90px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002102'), 
				prop: 'wrntStrtDd',
				minWidth: '110px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002136'), 
				prop: 'wrntStrtDdManual',
				minWidth: '170px',
				align: 'center',
				custom: true,
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001013'), //고객사업체명
				prop: 'custNm',
				minWidth: '90px',
				headerAlign: 'center',
				align: 'left'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002119'), 
				prop: 'licensePlate',
				minWidth: '90px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002122'), 
				prop: 'vehicleRegDt',
				minWidth: '90px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002123'), 
				prop: 'carWrntStrtDd',
				minWidth: '90px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002120'), 
				prop: 'carrierName',
				minWidth: '90px',
				align: 'center',
				align: 'left'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002108'), 
				prop: 'pmcChgrDt',
				minWidth: '170px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001814'), 
				prop: 'chgrNm',
				minWidth: '100px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002107'), //차수
				prop: 'ipnNos',
				align: 'center',
				sortable: false
			},
			
			
		];
	},
};
